import Color from '@/Enums/Color.enum';
import ExpandIcon from '@/components/Icons/ExpandIcon';
import { FileDownloadOutlined } from '@mui/icons-material';
import { IconButton, Typography, styled } from '@mui/material';
import classNames from 'classnames';
import { ReactNode, memo } from 'react';

interface IProps {
  label: ReactNode;
  value: ReactNode;
  className?: string;
  onView?: () => void;
  onDownload?: () => void;
}

const StyledIconButton = styled(IconButton)({
  padding: '2px',
  border: '1px solid rgb(230, 230, 230)',
  flex: 0,
  width: '20px',
  height: '20px',
});

const InfoSection = memo(({ label, value, className, onView, onDownload }: IProps) => {
  return (
    <div
      className={classNames('flex w-full py-2 flex-col items-center justify-center gap-1 border rounded-md', className)}
    >
      <Typography sx={{ color: Color.Grey, fontSize: '12px', lineHeight: '16px', fontWeight: 500 }} component='p'>
        {label}
      </Typography>
      <Typography
        sx={{
          color: Color.Primary,
          fontSize: '18px',
          lineHeight: '28px',
          fontWeight: 600,
          display: 'flex',
          gap: '4px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        component='p'
      >
        {onView ? (
          <StyledIconButton onClick={onView} size='small' aria-label='view'>
            <ExpandIcon width={14} height={14} />
          </StyledIconButton>
        ) : null}
        <span>{value}</span>
        {onDownload ? (
          <StyledIconButton aria-label='download' size='small' onClick={onDownload}>
            <FileDownloadOutlined titleAccess='download' fontSize='inherit' />
          </StyledIconButton>
        ) : null}
      </Typography>
    </div>
  );
});

export default InfoSection;
